import {
    AttachmentOpenAction,
    AttachmentViewState,
    getAttachmentDefaultOpenAction,
    AttachmentSelectionSource,
} from 'owa-attachment-data';
import { ClientItemId } from 'owa-client-ids';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import { ImageGalleryItem } from 'owa-sxsdata';

export default {
    ClickAttachment: {
        name: 'ClickAttachment',
        customData: (
            viewState: AttachmentViewState,
            attachmentSelectionSource: AttachmentSelectionSource,
            /* if instrumention context is not provided, usermailinteraction won't be logged.
            User mail interaction is specific to only search today.
            More information https://microsoft.sharepoint.com/teams/STCE/usb/_layouts/OneNote.aspx?id=%2Fteams%2FSTCE%2Fusb%2FShared%20Documents%2FCortana%20For%20Work%2Fcortana-for-work&wd=target%28Partners.one%7C229FF16A-FA84-4BFA-9C8E-A2A3FDBBD1C9%2FSearch%20Instrumentation%20With%20Execute%20Search%7CEB0BB605-BDD7-4048-8AC8-1DF427E2C9E4%2F%29 */
            instrumentationContext: InstrumentationContext,
            parentItemId: ClientItemId = null, // used if attachment is edited in SxS - to load draft into compose and to scroll to item on reading pane
            isDraft: boolean = false, // used to determine if attachment can be edited in SxS
            onBeforePreview?: () => void,
            createImageGallery?: () => Promise<ImageGalleryItem[]>,
            container?: HTMLElement
        ) => ({
            actionPerformed:
                AttachmentOpenAction[getAttachmentDefaultOpenAction(viewState.strategy)],
            actionSource: AttachmentSelectionSource[attachmentSelectionSource],
        }),
    },
};
